import { DataContextService, ResultWrapper } from '@seahorse/common';
import { Observable } from 'rxjs';
import { UserInfoModel, UserModel } from '../models/users.model';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export abstract class UsersDataService {
  protected _dataContext = inject(DataContextService);

  getProfile() {
    return this._dataContext.get<UserInfoModel>(`users/me`);
  }

  abstract getByOrganisation(
    loadInactiveUsers: boolean
  ): Observable<ResultWrapper<UserModel[]>>;

  abstract get(id: string): Observable<ResultWrapper<UserModel>>;
  abstract setUserIdentity(): Observable<string[]>;
  abstract add(user: UserModel): Observable<ResultWrapper<UserModel>>;
  abstract update(user: UserModel): Observable<ResultWrapper<UserModel>>;
}
